<template>
  <div style="height:100%;">
    <el-row style="height:55px;padding-bottom:15px;">
      <tool-bar ref="toolbar" @refreshTable="refreshTable" @search="search" :deletelist="selectdList"></tool-bar>
    </el-row>
    <el-row style="height:calc(100% - 55px - 42px)">
      <el-table :data="data" border style="width: 100%" height="100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="35">
        </el-table-column>
        <el-table-column prop="id" label="任务号" width="105" align="center">
        </el-table-column>
        <el-table-column prop="period" label="周期(分)" width="105">
        </el-table-column>
        <el-table-column prop="recording_length" label="录音时长(秒)" width="105">
        </el-table-column>
        <el-table-column prop="detail" label="任务说明">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="170">
        </el-table-column>
        <el-table-column label="扫描频率">
          <template slot-scope="scope">
            <el-tag style="margin-left:1%" v-for="(value,key) in scope.row.freq_range" :key="key" type="success" size="small">
              {{parseFreqRange(value)}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showWhiteList(scope.$index)">白名单</el-button>
            <el-button type="text" size="small" @click="edit(scope.$index)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="height:42px;padding-top:10px;">
      <PageNation ref='pageNation' @change="pageChange"></PageNation>
    </el-row>

    <edit ref='edit' :data='data[selectd_index]' @refreshAfterUpdate="refreshTable"></edit>
    <el-dialog :visible.sync="whiteListVisible" :close-on-click-modal='false' width="700px">
      <WhiteListOfTask ref="whiteList" :white-list-ids="data && data[selectd_index] ? data[selectd_index].whitelist:{}"></WhiteListOfTask>
    </el-dialog>
  </div>
</template>

<script>
  import Edit from "@/components/PeriodTask/Edit";
  import PageNation from "@/components/PeriodTask/PageNation";
  import ToolBar from "@/components/PeriodTask/ToolBar";
  import WhiteListOfTask from "@/components/Tables/WhiteListOfTask";
  export default {
    mounted() {
      this.SearchForDatas();
    },
    components: {
      Edit,
      PageNation,
      ToolBar,
      WhiteListOfTask
    },
    data() {
      return {
        selectd_index: "",
        areas: [],
        data: [],
        selectdList: [],
        whiteListVisible: false
      };
    },
    methods: {
      parseFreqRange(range) {
        if (range.length == 1) {
          return `${range[0]}`;
        } else {
          return `${range[0]}-${range[1]}`;
        }
      },

      handleSelectionChange(a) {
        let ids = [];
        for (let i = 0; i < a.length; i++) {
          const element = a[i];
          ids.push(element.id);
        }
        this.selectdList = ids
      },

      refreshTable() {
        this.$refs["pageNation"].getTotalsize();
        this.SearchForDatas();
      },

      pageChange() {
        let keyword = this.$refs["toolbar"].searchValue;
        if (keyword && keyword.replace(/(^\s*)|(\s*$)/g, "") != "") {
          keyword =
            keyword.replace(/(^\s*)|(\s*$)/g, "")
        } else {
          keyword = undefined;
        }
        this.SearchForDatas(keyword);
      },

      search() {
        let keyword = this.$refs["toolbar"].searchValue;
        if (keyword && keyword.replace(/(^\s*)|(\s*$)/g, "") != "") {
          keyword = keyword.replace(/(^\s*)|(\s*$)/g, "")
        } else {
          keyword = undefined;
        }
        this.$refs["pageNation"].getTotalsize(keyword).then(() => {
          this.SearchForDatas(keyword);
        });
      },

      SearchForDatas(keyword) {
        let params = {
          rows_per_page: this.$refs["pageNation"].size,
          current_page: this.$refs["pageNation"].page
        };
        if (keyword) {
          params.options = [{
            "type": "8",
            "name": "detail",
            "value": keyword
          }];
          if (keyword != "" && !isNaN(keyword)) {
            params.options.push({
              "type": "1",
              "name": "id",
              "value": keyword
            });
            params.operator = " OR ";
          }
        }
        this.$getJSON('/task/s_period_tasklst', params).then(res => {
          this.data = res.data;
        });
      },

      edit(index) {
        this.selectd_index = index;
        this.$refs["edit"].show();
      },
      showWhiteList(index) {
        this.selectd_index = index;
        this.whiteListVisible = true;
      }
    }
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PeriodTask/Table.vue